import { detect } from "detect-browser";

export const browser = detect();
